import { selectUserRoles } from "./roles";
export const selectAuth = (state) => state?.auth ?? null;
//user info
export const selectUserId = (state) => state.auth?.userId ?? null;
export const selectUserEmail = (state) => state?.auth?.email ?? "";

export const selectCurrentOrg = (state) => state.auth?.currentOrg ?? null;
export const selectHasSelectedOrg = (state) => Boolean(selectCurrentOrg(state));

export const selectSuggestFwoFactor = (state) =>
  state?.auth?.suggestFwoFactor ?? false;

export const selectOpenCookieDialog = (state) =>
  state?.auth?.openCookieDialog ?? false;
export const selectAcceptedEssentialCookies = (state) =>
  state?.auth?.acceptedEssentialCookies ?? null;
export const selectAcceptedAnalyticsCookies = (state) =>
  state?.auth?.acceptedAnalyticsCookies ?? null;
export const selectAcceptedEngagementCookies = (state) =>
  state?.auth?.acceptedEngagementCookies ?? null;

export const selectTwoFactorEnabled = (state) =>
  state?.auth?.twoFactorEnabled ?? false;

export const selectPasswordPolicy = (state) =>
  state?.auth?.passwordPolicy ?? null;

export const selectAvatarUrl = (state) => state?.auth?.avatarUrl ?? "";
export const selectHelpScout = (state) => state?.auth?.helpScout ?? null;
export const selectGuruu = (state) => state?.auth?.guruu ?? null;
export const selectRefiner = (state) => state?.auth?.refiner ?? null;

//token data

export const selectAccessToken = (state) => state.auth?.accessToken ?? null;

export const selectExpiresAt = (state) => state.auth?.expiresAt ?? null;

export const selectRestoringSession = (state) =>
  state?.auth?.restoringSession ?? false;

//auth status
export const selectAuthStage = (state) => state.auth?.stage ?? "";

export const selectIsAuthenticated = (state) => {
  const token = selectAccessToken(state);
  const expiresAt = selectExpiresAt(state);
  const authStage = selectAuthStage(state);

  if (!token || !expiresAt) return false;

  return Date.now() < expiresAt && authStage === "authenticated";
};

//user types
export const selectIsInternalUser = (state) => {
  const roles = selectUserRoles(state);
  return (
    roles.includes("SuperAdmin") ||
    roles.includes("OrdinaryAdmin") ||
    roles.includes("Supporter") ||
    roles.includes("Accounter") ||
    roles.includes("MarketplaceEditor") ||
    roles.includes("MarketplacePartner") ||
    roles.includes("NewsEditor")
  );
};

export const selectIsExternalUser = (state) => {
  const roles = selectUserRoles(state);
  return roles.includes("User");
};

export const selectIsNoOrgExternalUser = (state) =>
  selectIsAuthenticated(state) &&
  selectIsExternalUser(state) &&
  !selectHasSelectedOrg(state);

export const selectIsImpersonated = (state) =>
  state?.auth?.isImpersonated ?? false;

export const selectImpersonatedByUserId = (state) =>
  state?.auth?.impersonatedByUserId ?? null;

export const selectIdentitySwitching = (state) =>
  state?.auth?.identitySwitching ?? false;
